import { $t } from "@/lib/i18nHelpers";
import { FormFields, ListField } from "@/types";

export const systemName = "bank";

export const listField: ListField = { value: systemName, text: $t("Bank") };

export const formFields: FormFields = [
  {
    name: "bankCountry",
    label: $t("Bank country"),
    type: "radio",
    rules: ["required"],
    validationMode: "aggressive",
    options: [
      { text: $t("US"), value: true },
      { text: $t("Non-US"), value: false },
    ],
  },
  {
    name: "nameOnAccount",
    label: $t("Name on account"),
    rules: ["required"],
    validationMode: "aggressive",
  },
  {
    name: "bankName",
    label: $t("Bank name"),
    rules: ["required"],
    validationMode: "aggressive",
  },
  {
    name: "bankAddress",
    label: $t("Bank address"),
    rules: ["required"],
    validationMode: "aggressive",
  },
  {
    name: "bankAccountNumber",
    label: $t("Bank account number"),
    rules: ["required"],
    validationMode: "aggressive",
  },
  {
    name: "bankRouting",
    label: $t("Bank Routing/Sort code"),
    rules: ["required"],
    validationMode: "aggressive",
  },
  {
    name: "accountDetails",
    label: $t("Account details"),
    type: "textarea",
    placeholder: $t("Checking or savings account, etc."),
    autoGrow: true,
    rows: 3,
  },
];
